import { useCallback, useEffect, useState } from "react";

const SIDE_MENU_COLLAPSED_STORAGE_KEY = "backoffice:side-menu-collapsed";

function readStoredPreference(): boolean {
  try {
    return localStorage.getItem(SIDE_MENU_COLLAPSED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function storePreference(isCollapsed: boolean): void {
  try {
    localStorage.setItem(SIDE_MENU_COLLAPSED_STORAGE_KEY, String(isCollapsed));
  } catch {
    return;
  }
}

export function useSideMenuCollapsedPreference() {
  const [isSideMenuCollapsed, setIsSideMenuCollapsed] =
    useState(readStoredPreference);

  useEffect(() => {
    storePreference(isSideMenuCollapsed);
  }, [isSideMenuCollapsed]);

  const toggleSideMenuCollapsed = useCallback(
    () => setIsSideMenuCollapsed((isCollapsed) => !isCollapsed),
    [],
  );

  return { isSideMenuCollapsed, toggleSideMenuCollapsed };
}
